import React from 'react'
import { Icon, Image, Table, Dropdown, Button } from 'semantic-ui-react'
import './Serie.scss'
import { Link, withRouter } from 'react-router-dom'
import db, { storage } from '../../../utils/firebase'
import _, {map} from 'lodash'
import { useAuth } from '../../../context/authContext'
import AdminModificarSerie from './AdminModificarSerie'
import ModificarEpisodio from './ModificarEpisodio'

function Serie(props) {

    const {admin,setShowModal,setTitleModal,setContentModal}=useAuth()

    const{ match}=props
    const {params}=match
    const [dataSerie, setDataSerie] = React.useState(null)
    const [state, setState] = React.useState("temporada1")
    const [episodios,setEpisodios] = React.useState()
    const [loadingCapitulos,setLoadingCapitulos]=React.useState(false)
    const [idSerie,setIdSerie]=React.useState("")
    
    
    
    React.useEffect(() =>{
        if(params.id){
            setLoadingCapitulos(true)

            db.collection("series").where("uuidPoster","==",params.id).get().then((response)=>{
                if(response.docs.length>0){
                    const result = response.docs.map((doc)=>{
                        const data = doc.data()
                        data.id=doc.id
                        return{
                            ...data
                        }
                    })
                    setDataSerie(...result)
                }

            })
        }
        
    },[params?.id])
    
    

    React.useEffect(()=>{
        if(dataSerie){
            setLoadingCapitulos(true)


            db.collection("series").doc(dataSerie.id).collection(state).orderBy("createAt","asc").get().then((response)=>{
                if(response.docs.length>0){
                    const result = response.docs.map((doc)=>{
                        const data = doc.data()
                        data.id=doc.id
                        return{
                            ...data
                        }
                    })
                    setEpisodios(result)
                    
                }
            }).finally(()=>{
                
                setLoadingCapitulos(false)
            })
        }

    },[state,dataSerie])


    const p = map(dataSerie?.temporadas,(doc,index)=>{
        return{
            key:index+1,text:doc,value:doc

        }
    })
 
    
    const regresar = () =>{
        props.history.goBack()

    }
    

    const handleAdminSerie = ()=>{
        setShowModal(true)
        setTitleModal("modificar pelicula")
        setContentModal(<AdminModificarSerie
                        dataSerie={dataSerie}
                        idSerie={idSerie}
        />)
    }
    
    return (
        <>
            <div className="div-regresar" >
                <Button 
                    className="button-regresar" 
                    onClick={regresar}
                    >
                        <Icon
                            name="angle left"
                            size="small"
                        />
                </Button>
            </div>
            <div className="banner-serie" >
                <Image src={dataSerie?.urlPoster} />

                    <h2>{dataSerie?.description}</h2>
            </div>
            

                <Table  className="list-serie" inverted >

                  
                    <Table.Header  >
                        <Table.Row  >
                            <Table.HeaderCell  >
                                    <Dropdown 
                                        placeholder="temporada1" 
                                        scrolling
                                        options={p} 
                                        onChange={(e, data) => setState(data.value)}
                                        loading={loadingCapitulos}
                                        
                                        />
                            </Table.HeaderCell>
                            <Table.HeaderCell  className="tab-episodio" >Episodio</Table.HeaderCell>

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            map(episodios, itemSerie =>(
                                <RenderListEpisodio state={state} title={params?.id} key={itemSerie?.id} itemSerie={itemSerie} dataSerie={dataSerie} />
                            ))
                        }
                    </Table.Body>

                </Table>


            {
                admin && (
                    <div className='conatainerButtomAdminSerie' >

                        <Button
                            onClick={()=>handleAdminSerie()}
                        >Admisssn</Button>
                    </div>
                )
            }
        </>
        
    )
}
export default withRouter(Serie)

function RenderListEpisodio(props){

    const{itemSerie,state, title,dataSerie}=props
    const {admin,setShowModal,setTitleModal,setContentModal}=useAuth()


const video=itemSerie.video

const hadle=()=>{

  /*  db.collection("series").doc(dataSerie.id).collection(state).doc(itemSerie.id).delete().then(()=>{
        console.log("eliminado")
    })
    */

}

const handleUpdateEpisodio = ()=>{
    setShowModal(true)
    setTitleModal("Modificar episodio")
    setContentModal(<ModificarEpisodio episodio={itemSerie} serie={dataSerie} />)
}

    
   

    return(
    
    
        <Table.Row onClick={()=>hadle()} >
                <Table.Cell   >
                    <Icon name="play circle outline" />
                    {itemSerie.title}
                </Table.Cell>
                <Table.Cell 
                          >{itemSerie?.episodio}
                </Table.Cell>
                {
                    admin && (
                            <Table.Cell 
                                    >

                                    <Button
                                        content="update"
                                        onClick={()=>handleUpdateEpisodio()}
                                    />
                            </Table.Cell>
                        )
                }
        </Table.Row>                
         

       
        
    )
}